export interface ReportColumn {
  key: string;
  label: string;
  mobile?: boolean;
}
export const pageColumns: ReportColumn[] = [
  { key: "page", label: "Page", mobile: true },
  { key: "clicks", label: "Search clicks · GSC", mobile: true },
  { key: "click_change", label: "Click change · GSC" },
  { key: "impressions", label: "Impressions · GSC" },
  { key: "ctr", label: "CTR · GSC" },
  { key: "position", label: "Average position · GSC" },
  { key: "sessions", label: "Sessions · GA4", mobile: true },
  { key: "pageviews", label: "Page views · GA4" },
];
export const searchColumns: ReportColumn[] = [
  { key: "query", label: "Query", mobile: true },
  { key: "clicks", label: "Clicks · GSC", mobile: true },
  { key: "impressions", label: "Impressions · GSC", mobile: true },
  { key: "ctr", label: "CTR · GSC" },
  { key: "position", label: "Average position · GSC" },
];
export function tableFilters(params: URLSearchParams) {
  const page = Number(params.get("page"));
  return {
    q: params.get("q") ?? "",
    sort: params.get("sort") ?? "",
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
    page_size: 25,
  };
}
